import { __ } from "@wordpress/i18n";
const { Fragment } = wp.element;
const { MediaUpload, MediaUploadCheck } = wp.blockEditor;
const { Button, PanelRow, TextControl } = wp.components;
function BMediaUpload({ value, type = [], onSelect }) {
  return (
    <div className="bMediaUpload">
      <Fragment>
        <MediaUploadCheck>
          <MediaUpload
            allowedTypes={type}
            onSelect={(image) => onSelect(image.url)}
            render={({ open }) => <Button className="button button-primary" onClick={open} icon={"upload"}></Button>}
          />
        </MediaUploadCheck>
        <PanelRow className="width-100">
          <TextControl id="picker_field" value={value} onChange={(fileUrl) => onSelect(fileUrl)} />
        </PanelRow>
      </Fragment>
    </div>
  );
}

export default BMediaUpload;
